import { NgModule     } from '@angular/core';
import { FormsModule  } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NgxPaginationModule  } from 'ngx-pagination';

import { MatDatepickerModule   } from '@angular/material/datepicker'
import { MatNativeDateModule   } from '@angular/material/core'

import {
  BasicTableComponent,
  TableEntriesHeaderComponent,
  TableEntriesBodyComponent,
  EntriesNestedChildComponent,

  ContentHeaderComponent,
  DetailsHeaderComponent,

  PaginationComponent,
  PaginationSearchComponent,

  BasicPillsComponent,
  CustomTogglerComponent,
  ReleasesTableComponent,
  EditableInputComponent,
  DetailsFooterComponent,

  CandidateCardComponent,
  CandidatesCarouselComponent,
  PaginationSecondaryComponent,
  PillsButtonComponent,
  ListHeaderComponent
} from '@shared/components';

import { SwiperDirective } from '@shared/directives';
import { PillsPickerComponent } from '@shared/components/dynamic';
import { AvatarColorPipe, CapitalizePipe, SortByPipe } from '@shared/pipes';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,

    NgxPaginationModule,

    MatDatepickerModule,
    MatNativeDateModule
  ],
  declarations: [
    BasicTableComponent,
    TableEntriesHeaderComponent,
    TableEntriesBodyComponent,
    EntriesNestedChildComponent,

    EditableInputComponent,


    ContentHeaderComponent,
    DetailsHeaderComponent,
    DetailsFooterComponent,
    ListHeaderComponent,

    PaginationComponent,
    PaginationSearchComponent,

    CustomTogglerComponent,

    BasicPillsComponent,

    ReleasesTableComponent,

    CandidateCardComponent,
    CandidatesCarouselComponent,

    PaginationSecondaryComponent,
    PillsButtonComponent,
    PillsPickerComponent,

    SwiperDirective,
    CapitalizePipe,
    SortByPipe,
    AvatarColorPipe,
  ],
  exports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,

    CustomTogglerComponent,

    BasicTableComponent,
    TableEntriesHeaderComponent,
    TableEntriesBodyComponent,
    EntriesNestedChildComponent,

    EditableInputComponent,

    ContentHeaderComponent,
    DetailsHeaderComponent,
    DetailsFooterComponent,
    ListHeaderComponent,

    PaginationComponent,
    PaginationSearchComponent,

    BasicPillsComponent,

    ReleasesTableComponent,

    SwiperDirective,
    CapitalizePipe,
    SortByPipe,
    AvatarColorPipe,

    CandidatesCarouselComponent,

    PaginationSecondaryComponent,
    PillsButtonComponent,
    PillsPickerComponent
  ]
})
export class SharedModule {}
